/* eslint-disable */
import Api from '@/services/Api'

export default {
    process(data){
        try {

            return Api().get('grades/process/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getGSheetRecords(data){
        try {

            return Api().get('classrooms/gsheet/');
        }catch(err){
            console.log(err);
            return err
        }
    },
}
